import { React, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import useTranslationJobs from "../useTranslationJobs";
import useShowLoader from "../../common/loading-widgets/useShowLoader";
import HtmlUtils from "../../../utils/HtmlUtils";
import SimilarJobsResultList from "../search/SimilarJobsResultList";
import * as ROUTES from "../../../constants/routes";
import { useHistory } from "react-router-dom";
import ActionLink from "../../common/widgets/ActionLink";
import ActionButton from "../../common/widgets/ActionButton";
import ApprovalDetailsJob from "./ApprovalDetailsJob";
import VisibilityOutlinedIcon from "@material-ui/icons/VisibilityOutlined";
import RouterUtils from "../../../utils/RouterUtils";
import "./CandidateRejectedApplicationBlock.scss";
import CandidateApprovalStatusEnum from "../../candidates/CandidateApprovalStatusEnum";

export default function CandidateRejectedApplicationBlock(props) {
  const { job, applicationId, approval } = props;

  const history = useHistory();

  const redirectToApproved = () => {
    history.push(
      RouterUtils.injectParamsInRoute(
        ROUTES.RECRUITER_CANDIDATE_APPROVED_APPLICATION,
        {
          jobId: job._id,
          applicationId: applicationId,
        }
      )
    );
  };

  if (
    approval.candidateApprovalStatus === CandidateApprovalStatusEnum.APPROVED
  ) {
    redirectToApproved();
  }

  const { t, loading: tLoading } = useTranslationJobs();
  useShowLoader(tLoading, "CandidateRejectedApplicationBlock");

  const onClickApproval = () => {
    redirectToApproved();
  };

  const [show, setShow] = useState(false);
  const [scroll, setScroll] = useState(false);

  const showJob = () => {
    setShow(!show);
    setScroll(!scroll);
  };

  return (
    <>
      <div className="CandidateRejectedApplicationBlock">
        <div className="job-approval-div">
          <Row>
            <Col className="job-approval-text">
              {HtmlUtils.htmlToComponents(
                t("jobs:job_approval_action_text", {
                  name: approval.recruiterName,
                  job: job.title,
                })
              )}
            </Col>
          </Row>
          <Row className="rejected-text-row">
            <Col>
              {HtmlUtils.htmlToComponents(
                t("jobs:job_approval_rejected_status_text", {
                  name: approval.recruiterName,
                  job: job.title,
                })
              )}
            </Col>
          </Row>
          <Row className="call-to-action-row">
            <Col>
              <ActionButton
                className="become-spotter-action"
                onClick={() =>
                  onClickApproval()
                }
              >
                {t("jobs:job_approval_action")}
              </ActionButton>
            </Col>
          </Row>

          <Row className="show-detail-job-row-containeur">
            <Col className="show-detail-job-col">
              <VisibilityOutlinedIcon />
            </Col>
            <Col className="show-detail-job-col">
              <ActionLink href="#jobdescription" onClick={showJob}>
                {t("jobs:job_show_detail")}
              </ActionLink>
            </Col>
          </Row>
        </div>
        <Row>
          <Col id="jobdescription" className="job-details-div">
            <Row>
              <Col>
                <ApprovalDetailsJob
                  job={job}
                  applicationId={applicationId}
                  approval={approval}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </>
  );
}
